import { View, Text, Image, TextInput, TouchableOpacity } from 'react-native'
import React, { useRef, useState, useEffect } from 'react'
import styles from '../../../components/customUtils/Components/EmailWidgetStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import theme from '../../../../theme'
import { fetchAuthSession, getCurrentUser, updateUserAttributes } from 'aws-amplify/auth'
import { verifyEmailCode, verifyPhoneNumberCode } from '../../../utils/cognitoUtils'
import { request_edit_user_profile } from '../../../services/user.services'

const EmailWidget = ({ type, formData, user_data, closeBottomSheet, fieldsMap, setUpdated, fetchData }) => {
    const { languageFile } = getLanguage()
    const [verificationCode, setVerificationCode] = useState('')
    const [timer, setTimer] = useState(60) // Temporizador de 60 segundos
    const [isResendEnabled, setIsResendEnabled] = useState(false) // Estado para habilitar el botón de reenviar

    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000)
            return () => clearTimeout(countdown)
        } else {
            setIsResendEnabled(true) // Habilita el botón cuando el tiempo llega a 0
        }
    }, [timer])

    const handleResendCode = async () => {
        let phone = formData['Teléfono'].startsWith('+549') ? formData['Teléfono'] : `+549${formData['Teléfono']}`
        setIsResendEnabled(false)
        setTimer(60) // Restablecer el temporizador a 60 segundos
        const user = await getCurrentUser()

        try {
            if (type === 'phone') {
                await updateUserAttributes(user, { phone_number: phone })
            } else if (type === 'email') {
                updateUserAttributes(user, { email: formData['Email'] })
            }
        } catch (error) {
            console.error('Error reenviando el código:', error)
        }
    }

    const handleModalVerificationPhone = async (verificationCode) => {
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString()
        let verifyCode = await verifyPhoneNumberCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                editedData[fieldsMap[key]] = formData[key]
            }
            // if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
            //     editedData[fieldsMap[key]] = formData[key]
            // }
        }
        if (verifyCode['success']) {
            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
            await fetchData()
            closeBottomSheet(true)
            setUpdated(true)
        }
    }

    const handleModalVerification = async (verificationCode) => {
        // const database = await openDB()
        const session = await fetchAuthSession()
        const authToken = session.tokens?.accessToken?.toString()
        let verifyCode = await verifyEmailCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                editedData[fieldsMap[key]] = formData[key]
            }
            // if (formData.hasOwnProperty(key) !== user_data[fieldsMap[key]]) {
            //     editedData[fieldsMap[key]] = formData[key]
            // }
        }
        if (verifyCode['success']) {
            // setShowModalVerification(false)

            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
            await fetchData()
            closeBottomSheet(true)
            setUpdated(true)
        }
    }

    const handleVerification = () => {
        if (type === 'phone') {
            handleModalVerificationPhone(verificationCode)
        } else {
            handleModalVerification(verificationCode)
        }
    }

    return (
        <View style={styles.modalContainer}>
            {type === 'email' && <Image style={styles.image} source={require('../../../../assets/editEmail.png')} resizeMode='contain' />}
            {type === 'phone' && <Image style={styles.image} source={require('../../../../assets/editPhone.png')} resizeMode='contain' />}
            {type === 'email' && <Text style={styles.modalTitle}>Validá tu email</Text>}
            {type === 'phone' && <Text style={styles.modalTitle}>Validá tu celular</Text>}
            {type === 'email' && <Text style={styles.modalSubtitle}>Recibirás un código en tu correo electrónico para ingresarlo.</Text>}
            {type === 'phone' && <Text style={styles.modalSubtitle}>Recibirás un código SMS para ingresarlo.</Text>}
            <Text style={styles.modalSubtitle}>Si aún no recibiste el código, vuelve a intentarlo.</Text>
            <Text style={styles.modalTitle}>Código de verificación</Text>
            <View style={{ flexDirection: 'row', marginVertical: 10, marginHorizontal: 20 }}>
                <VerificationCodeInput setVerificationCode={setVerificationCode} />
            </View>
            <Text style={styles.modalSubtitle}>{timer > 0 ? `Puedes reenviar el código en ${timer} segundos` : '¿No recibiste el código?'}</Text>
            <View style={styles.buttonContainer}>
                <TouchableOpacity style={{ paddingVertical: 10 }} onPress={() => handleResendCode()} disabled={!isResendEnabled}>
                    <Text style={[styles.mainButtonText, { color: isResendEnabled ? theme.colors.colorPrimary : theme.colors.darkGray }]}>
                        Reenviar código
                    </Text>
                </TouchableOpacity>

                <TouchableOpacity style={[styles.mainButton, { backgroundColor: theme.colors.colorPrimary }]} onPress={() => handleVerification()}>
                    <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
                <View style={styles.spacer1}></View>
                {/*<TouchableOpacity style={styles.borderButton} onPress={() => closeBottomSheet(true)}>
                    <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                </TouchableOpacity>*/}
            </View>
            <View style={styles.spacer1}></View>
        </View>
    )
}
const VerificationCodeInput = ({ setVerificationCode }) => {
    const [code, setCode] = useState(new Array(6).fill('')) // Array de 6 dígitos vacíos
    const inputRefs = useRef([])

    // Maneja el cambio en cada TextInput
    const handleInputChange = (text, index) => {
        const newCode = [...code]
        newCode[index] = text
        setCode(newCode)

        // Si se ingresa un dígito, mueve el foco al siguiente input
        if (text && index < 5) {
            inputRefs.current[index + 1].focus()
        }

        // Si el código está completo (6 dígitos)
        if (newCode.join('').length === 6) {
            // console.log(newCode)
            setVerificationCode(newCode.join(''))
            // handleVerification(newCode.join(''));
        }
    }

    const handleKeyPress = (e, index) => {
        // Si se presiona la tecla de retroceso y el campo está vacío, mueve el foco al campo anterior
        if (e.nativeEvent.key === 'Backspace' && index > 0 && !code[index]) {
            inputRefs.current[index - 1].focus()
        }
    }

    return (
        <View style={{ flexDirection: 'row', paddingHorizontal: 20 }}>
            {code.map((digit, index) => (
                <TextInput
                    key={index}
                    style={[styles.inputCode, styles.inputCodeText]} //{styles.input}
                    keyboardType='numeric'
                    maxLength={1}
                    value={digit}
                    onChangeText={(text) => handleInputChange(text, index)}
                    onKeyPress={(e) => handleKeyPress(e, index)}
                    ref={(ref) => (inputRefs.current[index] = ref)} // Asigna referencia para el manejo de foco
                />
            ))}
        </View>
    )
}

export default EmailWidget
